import FormControlLabel from '@mui/material/FormControlLabel';
import { useState } from 'react';
import { TextField } from '@mui/material';
import { IOSSwitch } from '../common/IosSwitch';
import Collapse from '@mui/material/Collapse';
import { selectSecondSellerInfo } from '../../redux-state/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_SECOND_SELLER_INFO } from '../../redux-state/forms/types';

function SecondSellerInformation() {
  const [isFieldVisible, setIsFieldVisible] = useState(false);
  const secondSellerInfo = useSelector(selectSecondSellerInfo);
  const dispatch = useDispatch();

  const handleChange = (key, value) => {
    dispatch({
      type: UPDATE_SECOND_SELLER_INFO,
      payload: { key, value },
    });
  };

  return (
    <div>
      <div className={`flex flex-row justify-between p-4 ${isFieldVisible ? 'rounded-t-xl' : 'rounded-xl'} bg-white text-gray-700`}>
        <div className="text-md font-bold">Second Seller Information</div>
        <div className="flex flex-row">
          <div className="mt-1">{isFieldVisible ? 'Hide Detail' : 'Show Detail'}</div>
          <FormControlLabel
            control={<IOSSwitch sx={{ ml: 3 }} checked={isFieldVisible} onChange={(e) => setIsFieldVisible(e.target.checked)} />}
          />
        </div>
      </div>

      <Collapse in={isFieldVisible} timeout={500} unmountOnExit>
        <div className="flex flex-col bg-white p-4 gap-4 rounded-b-xl text-gray-900">
          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Second Seller First Name"
              variant="outlined"
              fullWidth
              value={secondSellerInfo.secondSellerFirstName}
              onChange={(e) => handleChange('secondSellerFirstName', e.target.value)}
            />
            <TextField
              label="Second Seller Middle Name"
              variant="outlined"
              fullWidth
              value={secondSellerInfo.secondSellerMiddleName}
              onChange={(e) => handleChange('secondSellerMiddleName', e.target.value)}
            />
            <TextField
              label="Second Seller Last Name"
              variant="outlined"
              fullWidth
              value={secondSellerInfo.secondSellerLastName}
              onChange={(e) => handleChange('secondSellerLastName', e.target.value)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Second Seller Company (if applicable)"
              variant="outlined"
              fullWidth
              value={secondSellerInfo.secondSellerCompany}
              onChange={(e) => handleChange('secondSellerCompany', e.target.value)}
            />
            <TextField
              label="Second Seller Address"
              variant="outlined"
              fullWidth
              value={secondSellerInfo.secondSellerAddress}
              onChange={(e) => handleChange('secondSellerAddress', e.target.value)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Second Seller City"
              variant="outlined"
              fullWidth
              value={secondSellerInfo.secondSellerCity}
              onChange={(e) => handleChange('secondSellerCity', e.target.value)}
            />
            <TextField
              label="Second Seller State"
              variant="outlined"
              fullWidth
              value={secondSellerInfo.secondSellerState}
              onChange={(e) => handleChange('secondSellerState', e.target.value)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Second Seller Zip"
              variant="outlined"
              fullWidth
              value={secondSellerInfo.secondSellerZip}
              onChange={(e) => handleChange('secondSellerZip', e.target.value)}
            />
            <TextField
              label="Second Seller Dealer Number (if applicable)"
              variant="outlined"
              fullWidth
              value={secondSellerInfo.secondSellerDealerNumber}
              onChange={(e) => handleChange('secondSellerDealerNumber', e.target.value)}
            />
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default SecondSellerInformation;
